function initMenu() {

    const   navbar_wrapper  = document.getElementById('smx-wrapper-navbar'),
            menu_toggler    = document.getElementById('main-nav-toggler'),
            navbar_dropdown = document.getElementById('navbar-nav-dropdown'),
            items_depth0    = navbar_dropdown.querySelectorAll('#main-menu > li'),
            items_depth0_r    = [...items_depth0].reverse(),
            dropdowns_depth0 = navbar_dropdown.querySelectorAll('#main-menu > li.menu-item-has-children > a');

    menu_toggler.addEventListener('click', ()=>{
        let is_open = menu_toggler.classList.contains('open');
        if(is_open){
            menu_toggler.classList.remove('open');
            navbar_wrapper.classList.remove('open');
            navbar_dropdown.classList.remove('open');

            items_depth0_r.forEach((item, index) => {
                setTimeout( ()=> item.classList.remove('show') , 50 * index );
            });

        }else{
            navbar_wrapper.classList.add('open');
            menu_toggler.classList.add('open');
            navbar_dropdown.classList.add('open');

            items_depth0.forEach((item, index) => {
                setTimeout( ()=> item.classList.add('show') , 50 * index );
            });


        }

    } );


    dropdowns_depth0.forEach((dropdown) => {
        dropdown.addEventListener('click', (e)=> {
            e.preventDefault();
            dropdown.parentElement.classList.toggle('open');
        })
    });

}

export default { initMenu }; 
